module.exports = __webpack_public_path__ + "static/img/biomass_256.4c5e238.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/biomass_256.png
// module id = V4zN
// module chunks = 0